import styles from './index.module.scss'

export function PinsSkeleton() {
  return <div className={styles.pins} />
}
